import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/bk2.png'
import _imports_1 from '../assets/star.png'
import _imports_2 from '../assets/star-empty.png'
import _imports_3 from '../assets/heart-black.png'
import _imports_4 from '../assets/bk1.png'
import _imports_5 from '../assets/hot.png'
import _imports_6 from '../assets/t1.png'
import _imports_7 from '../assets/t2.png'
import _imports_8 from '../assets/table.png'


const _withScopeId = n => (_pushScopeId("data-v-181ae027"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"100%"}
}, null, -1))
const _hoisted_2 = { class: "detail" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail_title" }, "Tomato Soup", -1))
const _hoisted_4 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_5 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  style: {"width":"24px"}
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "4.0", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","align-items":"center"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    style: {"width":"24px"}
  }),
  /*#__PURE__*/_createElementVNode("span", null, "362")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail_desc" }, "introduction of tomato introduction", -1))
const _hoisted_10 = { class: "detail_info" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "detail_info-avatar"
}, null, -1))
const _hoisted_12 = { class: "detail_info-name" }
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"detail_info-tab\" data-v-181ae027><div data-v-181ae027><span data-v-181ae027>consume</span><span data-v-181ae027>30min</span></div><div data-v-181ae027><span data-v-181ae027>Degree</span><span data-v-181ae027>Hard</span></div><div data-v-181ae027><span data-v-181ae027>consume</span><span data-v-181ae027>640Cal</span></div></div><div style=\"display:flex;justify-content:space-between;\" data-v-181ae027><img src=\"" + _imports_5 + "\" style=\"width:24px;height:auto;\" data-v-181ae027><div data-v-181ae027>Calorie consumption：20 minutes of fast running or 15 minutes of jogging</div></div>", 2)
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Temperature", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  style: {"width":"100%"}
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  style: {"width":"100%"}
}, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Ingredients List", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  style: {"width":"100%"}
}, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Recipe steps", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Ratings and Comments", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Tips", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Tags", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Show Your Works", -1))
const _hoisted_25 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Recommend", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer" }, "— Pictures For Reference Only —", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Step = _resolveComponent("Step")!
  const _component_Comments = _resolveComponent("Comments")!
  const _component_Tips = _resolveComponent("Tips")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_Recommend = _resolveComponent("Recommend")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
            return _createElementVNode("img", {
              src: _imports_1,
              style: {"width":"24px"},
              key: i
            })
          }), 64)),
          _hoisted_6,
          _hoisted_7
        ]),
        _hoisted_8
      ]),
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.info.name), 1),
        _hoisted_13
      ]),
      _hoisted_15,
      _hoisted_16,
      _hoisted_17,
      _hoisted_18,
      _hoisted_19,
      _hoisted_20,
      _createVNode(_component_Step, { list: _ctx.popular }, null, 8, ["list"]),
      _hoisted_21,
      _createElementVNode("div", null, [
        _createVNode(_component_Comments, { list: _ctx.popular }, null, 8, ["list"])
      ]),
      _hoisted_22,
      _createVNode(_component_Tips, { list: _ctx.popular }, null, 8, ["list"]),
      _hoisted_23,
      _createVNode(_component_Tag, { list: _ctx.list }, null, 8, ["list"]),
      _hoisted_24,
      _createVNode(_component_Recommend, { list: _ctx.popular }, null, 8, ["list"]),
      _createElementVNode("div", _hoisted_25, [
        _createVNode(_component_Button, { txt: "Upload Cooking Pictures" })
      ]),
      _hoisted_26,
      _createVNode(_component_Recommend, { list: _ctx.popular }, null, 8, ["list"]),
      _hoisted_27
    ])
  ], 64))
}